import { useState } from 'react'
import * as Sentry from '@sentry/react'

const CopyIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
)

const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="20 6 9 17 4 12" />
  </svg>
)

const ShareIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
)

function ShareLink() {
  const [copied, setCopied] = useState(false)

  const copyLink = async () => {
    const link = window.location.href
    try {
      await navigator.clipboard.writeText(link)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy:', err)
      Sentry.captureException(err)
    }
  }

  const shareLink = async () => {
    const link = window.location.href
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Join my video call',
          text: 'Click to join my Call Mom video call',
          url: link
        })
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('Failed to share:', err)
          Sentry.captureException(err)
        }
      }
    }
  }

  return (
    <div className="share-link-container">
      <p>Share this link to invite someone</p>
      <div className="share-link-input">
        <input
          type="text"
          value={window.location.href}
          readOnly
          onClick={(e) => e.target.select()}
        />
        <button onClick={copyLink} title={copied ? 'Copied!' : 'Copy'}>
          {copied ? <CheckIcon /> : <CopyIcon />}
        </button>
        {navigator.share && (
          <button onClick={shareLink} title="Share">
            <ShareIcon />
          </button>
        )}
      </div>
    </div>
  )
}

export default ShareLink
